import { useEffect, useState } from 'react';
import qs from 'qs';
/**
 * This hook is used to persist on local storage the URL parameter 'guest-access-hash'
 *
 * @param {Object{ vepTokens, setVepTokens }} props - A props list with the current VEP tokens and a callback for persisting vep tokens on local storage.
 * @return {null} - No return value.
 */
const useSetGuestAccessHashFromUrlToLocalStorage = ({ vepTokens, setVepTokens }) => {
    const [gahSettedState, setGahSettedState] = useState(false);

    useEffect(() => {
        const queryParams = qs.parse(window.location.search, {
            ignoreQueryPrefix: true,
        });
        const queryGuestAccessHash = queryParams['guest-access-hash'];
        // If the guest access in the query is different than the one we previously stored, this is a
        // new guest and we should clear out old data.
        const shouldResetTokens =
            Boolean(vepTokens?.guestAccessHash && queryGuestAccessHash !== vepTokens?.guestAccessHash) ||
            !queryGuestAccessHash;

        setVepTokens({
            ...vepTokens,
            ...(shouldResetTokens && { accessToken: null, checkInToken: null }),
            guestAccessHash: queryGuestAccessHash,
        });
        setGahSettedState(true);
    }, []);

    return gahSettedState;
};

export default useSetGuestAccessHashFromUrlToLocalStorage;
